"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.user = undefined;

var _merge = require("lodash/merge");

var _merge2 = _interopRequireDefault(_merge);

var _omit = require("lodash/omit");

var _omit2 = _interopRequireDefault(_omit);

var _actionTypes = require("../actions/actionTypes");

var actionTypes = _interopRequireWildcard(_actionTypes);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var user = exports.user = function user() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var action = arguments[1];

    var user = {},
        nextState = {};

    switch (action.type) {
        case actionTypes.GET_CURRENT_USER_SUCCESS:
            nextState = action.response;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.SAVE_CARD_SUCCESS:
            nextState = action.response;
            nextState.has_credit_card = true;
            return (0, _merge2.default)({}, state, nextState);
            break;
        case actionTypes.UPGRADE_BILLING_SUCCESS:
            nextState = (0, _merge2.default)({}, state);
            nextState.has_premium_account = true;
            nextState.permissions.market = true;
            return (0, _merge2.default)({}, state, nextState);
            break;
        default:
            return state;
            break;
    }

    return Object.assign({}, state, nextState);
};